import React from 'react';
import { FormattedMessage } from '../../../../util/reactIntl';
import { CheckIcon } from '../icons';
import css from './Highlights.module.css';

const transportIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082557/socialbnb/assets/icons/equipment/Parking.webp';
const staysIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082538/socialbnb/assets/icons/characteristics/Tiny_House.webp';
const groupIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082529/socialbnb/assets/icons/characteristics/Family.webp';
const activityIcon =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082520/socialbnb/assets/icons/baloon.webp';

const Highlights = ({ publicData = {}, currentLanguage = 'de', isExperienceType = false }) => {
  if (!isExperienceType) {
    return null;
  }

  const descriptionFieldsToShow = publicData?.descriptionFieldsToShow || {};
  const intro =
    currentLanguage === 'de'
      ? publicData?.ActivityHighlights_de || publicData?.ActivityHighlights
      : publicData?.ActivityHighlights || publicData?.ActivityHighlights_de;

  const highlightItems = [
    {
      key: 'stay',
      icon: staysIcon,
      labelId: 'Highlights.accommodation',
      content:
        currentLanguage === 'de' ? publicData?.wIncludedStay_de : publicData?.wIncludedStay,
      show: descriptionFieldsToShow.wIncludedStayShow,
    },
    {
      key: 'activity',
      icon: activityIcon,
      labelId: 'Highlights.activities',
      content:
        currentLanguage === 'de'
          ? publicData?.wIncludedActivity_de
          : publicData?.wIncludedActivity,
      show: descriptionFieldsToShow.wIncludedActivityShow,
    },
    {
      key: 'group',
      icon: groupIcon,
      labelId: 'Highlights.smallGroup',
      content:
        currentLanguage === 'de' ? publicData?.wIncludedGroup_de : publicData?.wIncludedGroup,
      show: descriptionFieldsToShow.wIncludedGroupShow,
    },
    {
      key: 'transport',
      icon: transportIcon,
      labelId: 'Highlights.transport',
      content:
        currentLanguage === 'de'
          ? publicData?.wIncludedTransport_de
          : publicData?.wIncludedTransport,
      show: descriptionFieldsToShow.wIncludedTransportShow,
    },
  ];

  const visibleItems = highlightItems.filter(
    item => item.content && item.content.trim().length > 0 && (item.show !== false)
  );

  const itemsToRender =
    visibleItems.length > 0
      ? visibleItems.slice(0, 4)
      : highlightItems.filter(item => item.content && item.content.trim().length > 0).slice(0, 4);

  const notIncludedText =
    currentLanguage === 'de'
      ? publicData?.notIncludedPrice_de || publicData?.notIncludedPrice
      : publicData?.notIncludedPrice || publicData?.notIncludedPrice_de;

  const showHighlightsContent = itemsToRender.length > 0 || intro;

  return (
    <section className={css.section} data-elbaction="visible:vis highlights">
      {showHighlightsContent && (
        <>
          <h2 className={css.title}>
            <FormattedMessage id="ListingPage.highlights" />
          </h2>
          {intro && <p className={css.intro}>{intro}</p>}
          {itemsToRender.length > 0 && (
            <div className={css.grid}>
              {itemsToRender.map(item => (
                <article key={item.key} className={css.card}>
                  <div className={css.iconWrap}>
                    <img src={item.icon} alt="" className={css.iconImg} />
                  </div>
                  <div className={css.cardTitle}>
                    <FormattedMessage id={item.labelId} />
                  </div>
                  <div className={css.cardText}>{item.content}</div>
                </article>
              ))}
            </div>
          )}
        </>
      )}

      {notIncludedText && (
        <div className={css.notIncluded}>
          <svg
            className={css.notIncludedIcon}
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.9"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 16v-4" />
            <path d="M12 8h.01" />
          </svg>
          <div className={css.notIncludedText}>
            <strong className={css.notIncludedLabel}>
              <FormattedMessage id="Highlights.notInPrice" />
            </strong>{' '}
            {notIncludedText}
          </div>
        </div>
      )}

      <div className={css.reassurance}>
        <div className={css.reassuranceItem}>
          <CheckIcon className={css.reassuranceIcon} size={19} aria-hidden="true" />
          <FormattedMessage id="Highlights.reassurancePayAfterConfirm" />
        </div>
        <div className={css.reassuranceItem}>
          <CheckIcon className={css.reassuranceIcon} size={19} aria-hidden="true" />
          <FormattedMessage id="Highlights.reassuranceFreeCancel" />
        </div>
      </div>
    </section>
  );
};

export default Highlights;
